import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import { isFunction } from 'ggApp/utils/function';
import { DropDown, ItemText, Circle } from './styled';

const ColorSelector = ({ className, colorsList, selectedIndex, onOptionSelect }) => {
    const colours = useMemo(() => {
        return colorsList.reduce((res, item) => {
            return res.concat({
                label: item.name,
                value: item.name,
                ...(item.backgroundColor && {
                    icon: <Circle variantColor={item.backgroundColor} />,
                }),
            });
        }, []);
    }, [colorsList]);

    const onChange = useCallback(
        (item) => {
            const selectedItem = colorsList.find((c) => c.name === item.value);
            if (isFunction(onOptionSelect) && selectedItem) {
                onOptionSelect(selectedItem);
            }
        },
        [onOptionSelect, colorsList],
    );
    if (!colorsList.length) return null;
    return (
        <DropDown
            className={className}
            options={colours}
            defaultValue={colours[selectedIndex]}
            onChange={onChange}
            overrides={{
                ItemText: { component: ItemText },
            }}
        />
    );
};

ColorSelector.propTypes = {
    className: PropTypes.string,
    colorsList: PropTypes.arrayOf(PropTypes.object),
    selectedIndex: PropTypes.number,
    onOptionSelect: PropTypes.func,
};

ColorSelector.defaultProps = {
    className: '',
    colorsList: [],
    selectedIndex: null,
    onOptionSelect: () => {},
};

export default ColorSelector;
